import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import {
  formattedTripDate,
  formattedTripTime,
  formatTimeToIST,
} from "../utils/dateFormater";
import CabRequestServices from "../services/externalServices/cabRequestServices";
import "./style.css";
import BidTable from "./BidTable";
import TripTable from "./TripTable";
import PackageServices from "../services/externalServices/TourPackageServices/packageServices";
import PackageDetailsDialog from "./PackageDetailsDialog";
import { useDispatch, useSelector } from "react-redux";
import AutoBidMatrixLogsService from "../services/externalServices/autoBidMatrixLogServices";
import { set } from "mongoose";
import AutoBidMatrixLogDetailsDialog from "./AutoBidMatrixLogDetailsDialog";

function CabRequestList() {
  const dispatch = useDispatch();
  const { serviceType } = useSelector((state) => state.serviceType.serviceType);
  const [cabRequestData, setCabRequestData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [totalRows, setTotalRows] = useState(0);
  // const [serviceType, setServiceType] = useState("TourPackage");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedBid, setSelectedBid] = useState(null);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [tripDialogOpen, setTripDialogOpen] = useState(false);
  const [packageDetails, setPackageDetails] = useState();
  const [packageDialogOpen, setPackageDialogOpen] = useState(false);
  const [logs, setLogs] = useState([]);
  const [logsDialogOpen, setLogsDialogOpen] = useState(false);

  // useEffect(() => {
  //   const fetchCabRequests = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await CabRequestServices.getAllCabRequests(
  //         page + 1,
  //         rowsPerPage,
  //         serviceType
  //       );
  //       console.log("response===============in cabnrequest list", response);
  //       console.log("rowsPerPage", rowsPerPage, page);
  //       setCabRequestData(formatData(response.data));
  //       setTotalRows(response.total);
  //     } catch (err) {
  //       console.error("Error fetching cab requests:", err);
  //       setError("Failed to load data.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchCabRequests();
  // }, [page, rowsPerPage, serviceType]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Step 1: Get logs
        const logsResponse = await AutoBidMatrixLogsService.getAllLogs();

        // Step 2: Get cab requests
        const cabRequestsResponse = await CabRequestServices.getAllCabRequests(
          page + 1,
          rowsPerPage,
          serviceType
        );

        // Step 3: Append matching logs to each request
        const enrichedData = cabRequestsResponse.data.map((request) => {
          const matchedLog = logsResponse.find(
            (log) => log.cabRequestId === request._id
          );
          console.log("matchedLog", matchedLog);

          return {
            ...request,
            log: matchedLog?._id, // ✅ Add the logs here
          };
        });

        // Step 4: Format and set state
        setCabRequestData(formatData(enrichedData));
        setTotalRows(cabRequestsResponse.total);
      } catch (err) {
        console.error("Error loading data:", err);
        setError("Failed to load data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [page, rowsPerPage, serviceType]);

  const getPackageDetails = async (id) => {
    try {
      const res = await PackageServices.getPackageById(id);
      console.log("package details", res);
      setPackageDetails(res);
      setPackageDialogOpen(true);
    } catch (error) {
      console.error("Error while getting the package  details id", error);
    }
  };

  

  const formatData = (data) => {
    return data.map((request) => ({
      ...request,
      id: request._id,
      request_created_at: formatTimeToIST(request.created_at),
      userName: request.user
        ? `${request.user.first_name} ${request.user.last_name}`
        : "N/A",
      userPhoneNumber: request.user ? `${request.user.phone_number}` : "N/A",
      pickupLocation: request.pickup_location
        ? `${request.pickup_location.title}`
        : "N/A",
      tripDate: formattedTripDate(request.tripDate),
      tripTime: formattedTripTime(request.tripTime),
      bids: request.bids || [],
      bidCount: request.bids.length,
      logs:request.log,
      ridersFromNotifications: request.ridersFromNotifications || [],
    }));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const handleServiceTypeChange = (event) => {
  //   setServiceType(event.target.value);
  //   setPage(0);
  // };

  const handleDialogOpen = (bid) => {
    setSelectedBid(bid);
    setDialogOpen(true);
  };
  const handleDialogOpenWithLogs = (logID) => {
    setLogs(logID);
    setLogsDialogOpen(true)
  }
  const handleDialogWithLogsClose = () => {
    setLogsDialogOpen(false)
  }
  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedBid(null);
  };

  const handleTripTableDialogOpen = (trip) => {
    setSelectedTrip(trip);
    setTripDialogOpen(true);
  };
  const handleTripTableDialogClose = (trip) => {
    setTripDialogOpen(false);
    setSelectedTrip(null);
  };

  const handlePackageDialogClose = () => {
    setPackageDialogOpen(false);
    setPackageDetails(null);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  // Columns configuration for DataGrid
  const columns = [
    {
      field: "_id",
      headerName: "CabRequest ID",
      width: 150,
      renderCell: (params) => (
        <Link
          to={`/cabrequestdetails/${params.value}`}
          state={{ cabRequest: params.row }}
          className="text-decoration-none text-dark font-weight-bold"
        >
          {params.value}
        </Link>
      ),
    },
    { field: "request_created_at", headerName: "Requested Time", width: 180 },
    {
      field: "created_at",
      headerName: "Bid Timing",
      width: 180,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && formatTimeToIST(bid.created_at);
      },
    },
    { field: "pickupLocation", headerName: "Pickup Location", width: 180 },
    { field: "userName", headerName: "User Name", width: 180 },
    { field: "userPhoneNumber", headerName: "User PhoneNumber", width: 180 },
    { field: "tripDate", headerName: "Trip Date", width: 150 },
    { field: "tripTime", headerName: "Trip Time", width: 150 },
    {
      field: "packageId",
      headerName: "Package",
      width: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => getPackageDetails(params.value)}
        >
          {params.value}
        </Button>
      ),
    },
    {
      field: "ridersFromNotifications",
      headerName: "Notification Sent To",
      width: 300,
      renderCell: (params) => {
        const riders = params.row.ridersFromNotifications;

        if (!riders || riders.length === 0) {
          return "No Riders Notified";
        }

        // Format for tooltip (line breaks for readability)
        const tooltipText = riders
          .map((r) => `${r.first_name} (${r.phone_number})`)
          .join("\n");

        return (
          <Tooltip
            title={
              <span style={{ whiteSpace: "pre-line" }}>{tooltipText}</span>
            }
            arrow
          >
            <Box
              sx={{
                maxHeight: 60,
                overflowY: "auto",
                whiteSpace: "normal",
                lineHeight: 1.4,
                paddingRight: 1,
                cursor: "pointer",
              }}
            >
              {riders.map((r) => (
                <div key={r._id}>
                  {r.first_name} ({r.phone_number})
                </div>
              ))}
            </Box>
          </Tooltip>
        );
      },
    },
    { field: "status", headerName: "CabRequest Status", width: 180 },
    {
      field: "bidStatus",
      headerName: "Bid Status",
      width: 150,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? "Accepted" : "Not Accepted";
      },
    },
    {
      field: "bidCount",
      headerName: "Bid Count",
      width: 130,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => handleDialogOpen(params.row.bids)}
        >
          {params.value}
        </Button>
      ),
    },
    {
      field: "logs",
      headerName: "AutoBidMatrix LogsId",
      width: 200,
       renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => handleDialogOpenWithLogs(params.row.logs)}
        >
          {params.value}
        </Button>
      ),
    },
    {
      field: "driverName",
      headerName: "Driver Name",
      width: 180,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted
          ? `${bid.rider.first_name} ${bid.rider.last_name}`
          : null;
      },
    },
    {
      field: "driverPhoneNumber",
      headerName: "Driver PhoneNumber",
      width: 180,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.rider.phone_number : null;
      },
    },
    {
      field: "riderFee",
      headerName: "Rider Fee",
      width: 150,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.riderFee : null;
      },
    },
    {
      field: "discount",
      headerName: "Discount",
      width: 150,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.pricing.discount.value : null;
      },
    },
    {
      field: "discountedPrice",
      headerName: "Discounted Price",
      width: 180,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.pricing.discountedPrice.value : null;
      },
    },
    {
      field: "tax",
      headerName: "Tax",
      width: 150,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.pricing.tax.total.value : null;
      },
    },
    {
      field: "finalAmount",
      headerName: "Final Amount",
      width: 150,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.pricing.finalAmount : null;
      },
    },
    {
      field: "id",
      headerName: "TripId",
      width: 150,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        if (!bid || !bid.isAccepted || !bid.trip) return null;

        return (
          <Button
            variant="text"
            color="primary"
            onClick={() => handleTripTableDialogOpen(bid.trip)} // Add the click handler
          >
            {bid.trip._id}
          </Button>
        );
      },
    },
    {
      field: "trip_start_time",
      headerName: "Trip Start Time",
      width: 180,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        // console.log("bid[0]?.trip?.trip_start_time",bid.trip?.trip_start_time)
        return bid && bid.isAccepted
          ? formattedTripTime(bid.trip?.trip_start_time)
          : null;
      },
    },
    {
      field: "trip_end_time",
      headerName: "Trip End Time",
      width: 180,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted
          ? formattedTripTime(bid.trip?.trip_end_time)
          : null;
      },
    },
    {
      field: "startOtp",
      headerName: "Start Otp",
      width: 150,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.trip?.startOtp : null;
      },
    },
    {
      field: "endOtp",
      headerName: "End Otp",
      width: 150,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.trip?.endOtp : null;
      },
    },
    {
      field: "tripStatus",
      headerName: "Trip Status",
      width: 180,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.trip?.status : null;
      },
    },
    {
      field: "paymentMode",
      headerName: "Payment Mode",
      width: 180,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.trip?.payment : null;
      },
    },
    {
      field: "paymentUtrNumber",
      headerName: "Payment UTR Number",
      width: 180,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted
          ? bid.trip?.paymentDetails?.paymentInstrument?.utr
          : null;
      },
    },
    {
      field: "paymentStatus",
      headerName: "Payment Status",
      width: 180,
      renderCell: (params) => {
        const bid = params.row.bids[0];
        return bid && bid.isAccepted ? bid.trip?.paymentDetails?.state : null;
      },
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      {/* <Box
        sx={{ marginBottom: 2, display: "flex", alignItems: "center", gap: 2 }}
      >
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="serviceType-filter-label">Service Type</InputLabel>
          <Select
            labelId="serviceType-filter-label"
            id="serviceType-filter"
            value={serviceType}
            onChange={handleServiceTypeChange}
            label="Service Type"
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="Auto">Auto</MenuItem>
            <MenuItem value="TourPackage">Tour Package</MenuItem>
          </Select>
        </FormControl>
      </Box> */}
      <div style={{ height: 450, width: "100%" }}>
        {/* <DataGrid
     
          rows={cabRequestData}
          columns={columns}
          pageSize={rowsPerPage}
          rowsPerPageOptions={[15, 25, 50]} 
          pagination
          paginationMode="server"
          rowCount={totalRows}
          onPageChange={handleChangePage}
          onPageSizeChange={handleChangeRowsPerPage}
        /> */}
        <DataGrid
          rows={cabRequestData} // Display only the current page's data
          columns={columns}
          pageSize={rowsPerPage}
          pagination={false} // Disable built-in pagination
          hideFooter={true}
        />
        <TablePagination
          component="div"
          count={totalRows} // Total number of rows
          page={page} // Current page
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage} // Rows per page
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[15, 25, 50]} // Options for rows per page
        />
      </div>

      {/* Dialog to show bid details */}
      {/* Dialog to show bid details */}
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        fullWidth
        maxWidth="lg" // Options: 'xs', 'sm', 'md', 'lg', 'xl'
        sx={{ "& .MuiDialog-paper": { width: "90%", maxHeight: "90%" } }}
      >
        <DialogTitle>Bid Details</DialogTitle>
        <DialogContent>
          <BidTable bids={selectedBid} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={tripDialogOpen}
        onClose={handleTripTableDialogClose}
        fullWidth
        maxWidth="lg" // Options: 'xs', 'sm', 'md', 'lg', 'xl'
        sx={{ "& .MuiDialog-paper": { width: "90%", maxHeight: "90%" } }}
      >
        <DialogTitle>Trip Details</DialogTitle>
        <DialogContent>
          <TripTable trip={selectedTrip} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTripTableDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={packageDialogOpen}
        onClose={handlePackageDialogClose}
        fullWidth
        maxWidth="md" // Options: 'xs', 'sm', 'md', 'lg', 'xl'
        sx={{ "& .MuiDialog-paper": { width: "90%", maxHeight: "90%" } }}
      >
        <DialogTitle>Package Details</DialogTitle>
        <DialogContent>
          <PackageDetailsDialog packageData={packageDetails} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePackageDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

          <Dialog
        open={logsDialogOpen}
        onClose={handleDialogWithLogsClose}
        fullWidth
        maxWidth="md" // Options: 'xs', 'sm', 'md', 'lg', 'xl'
        sx={{ "& .MuiDialog-paper": { width: "90%", maxHeight: "90%" } }}
      >
        <DialogTitle>Logs Details</DialogTitle>
        <DialogContent>
          {/* <PackageDetailsDialog packageData={packageDetails} /> */}
          <AutoBidMatrixLogDetailsDialog logData={logs} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogWithLogsClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CabRequestList;
